<template>
	<div id="formView">
		<div>
			<LoadingOverlay :message="message" :ocrId="ocrTaskId" />
		</div>
		<div class="highlight">
			<h1 id="instructions">{{ $t("Opened") }}</h1>
			<div class="templateButtons">
				<div>
					<button @click="showTemplateModal" type="button" class="myTemplatesButton">{{
						$t("formview.MyTemplates") }}</button>
					<teleport to="body">
						<div class="modalTemplates" v-show="templateModalOpen" @click="handleClick">
							<div class="modalViewTemplates">
								<templateModal v-show="templateModalOpen" @close="closeTemplateModal"
									:templates="templates" @apply-template="applyTemplate"
									@apply-manual-template="applyManualTemplate" @remove-template="removeTemplate" />
							</div>
						</div>
					</teleport>
				</div>
				<div>
					<button @click="showTemplateNameModal" type="button" class="saveTemplateButton"
						:disabled="inputHasNoValue"
						:style="{ background: inputHasNoValue ? '#ccc' : '#2156A4', color: inputHasNoValue ? 'gray' : '#fff' }">{{
							$t("formview.SaveTemplate") }}</button>
					<teleport to="body">
						<div class="modalNameTemplates" v-show="templateNameModalOpen" @click="handleClick">
							<div class="modalViewNameTemplates">
								<templateNameModal v-show="templateNameModalOpen" @close="closeTemplateNameModal"
									:templateNames="templateNames" :content="randomData" @save-template="grabValues" />
							</div>
						</div>
					</teleport>

				</div>
			</div>
		</div>

		<div class="formSection">
			<div class="width100">

				<div class="inline-flex">
					<h2>{{ $t("ResultViewButtons.AnyData") }}</h2>
					<button class="add-button" @click="addFormField()">{{ $t("formview.addFormField") }}</button>
				</div>

				<div class="inline-flex">
					<div>
						<div class="ocrDescription" @click="showOcrHelpModal">{{ $t("formview.help") }}</div>
						<OcrHelpModal v-show="ocrHelpModalOpen" @close="closeOcrHelpModal" />
					</div>
				</div>

			</div>
			<div v-if="showRandomData" class="formFields">
				<div class="formField" v-for="(input, index) in randomData" :key="index">
					<div class="inputWrapper">
						<input class="formInput" autocomplete="off" v-show="datePickerHide(input.selectedOption.type)"
							v-model="input.value" :id="input.key2" :type="input.selectedOption.type"
							:description="$t('ResultViewButtons.AnyDataWrite')" />

						<div class="formField-actions">
							<!-- Icon toggle button -->
							<button v-if="!input.diacriticsChecked"
								type="button"
								@click="input.as_suffix = !input.as_suffix"
								:aria-pressed="input.as_suffix"
								class="icon-toggle-button"
							>
								<img
								:src="input.as_suffix ? suffixOn : suffixOff"
								alt="Suffix toggle"
								class="prefix-icon"
								/>
							</button>

							<button v-if="!input.diacriticsChecked"
								type="button"
								@click="input.as_prefix = !input.as_prefix"
								:aria-pressed="input.as_prefix"
								class="icon-toggle-button"
							>
								<img
								:src="input.as_prefix ? prefixOn : prefixOff"
								alt="Prefix toggle"
								class="prefix-icon"
								/>
							</button>

							<button
								type="button"
								@click="input.diacriticsChecked = !input.diacriticsChecked"
								:aria-pressed="input.as_prefix"
								class="icon-toggle-button"
							>
								<img
								:src="input.diacriticsChecked ? presnaZhodaOn : presnaZhodaOff"
								alt="Prefix toggle"
								class="prefix-icon"
								/>
							</button>

							<img 
								class="addRemoveFormButtons" 
								@click="removeFormField(index)" 
								v-if="index !== 0" 
								:src="minusSvg" 
							/>

							<img
								class="addRemoveFormButtons" 
								@click="showOcrHelpModal()" 
								v-if="index === 0" 
								:src="infoSvg"
								style="visibility: hidden;"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="formButtons">
			<div id="ocr">
				<div id="inlineOcr">
					<div class="ocrRadio" v-for="option in ocrOptions" :key="option.value">
						<input class="ocrInput" type="radio" :value="option.value" v-model="ocrprocess"
							:id="option.value">
						<label class="ocrLabel" :for="option.value">{{ $t(`formview.`+ option.text) }}</label>
					</div>
				</div>
				<div id="ocrStatus">
					<p id="ocrStatusText">{{ $t("formview.NumberOfDoc") }} {{ ocrCurrentProcesses }}/{{ ocrCombinedCap
					}}</p>
				</div>
			</div>

			<div class="button-box">
				<div>
					<button @click="sendFilesToAnonyma(false, false)" class="confirmButton" :disabled="inputHasNoValue"
						:style="{ background: inputHasNoValue ? '#ccc' : '#2156A4', color: inputHasNoValue ? 'gray' : '#fff' }">
						{{ $t("ResultViewButtons.ConfirmButton") }}
					</button>
				</div>
				<div>
					<button @click="sendFilesToAnonyma(true, false)" class="secondary_btn" :disabled="gotMultipleFiles">
						{{ $t("ResultViewButtons.manualAnotation") }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useCookies } from "vue3-cookies";
import EnvProvider from "jvjr-docker-env";
import LoadingOverlay from "../components/LoadingOverlay.vue";
import TabsComponent from "../components/TabsComponent.vue";
import '../../node_modules/pdfjs-dist/build/pdf.js'
import { active, AnnotationFactory } from '../../public/pdfAnnotate.js'
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist'
import { ref } from "vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import templateModal from "../components/TemplatesModal.vue"
import templateNameModal from "../components/TemplateNameModal.vue";
import { v4 as uuidv4 } from "uuid";
import OcrHelpModal from "../components/OcrHelpModal.vue";

export default {
	name: "FormView",
	components: { LoadingOverlay, VueDatePicker, templateModal, templateNameModal, OcrHelpModal, TabsComponent },
	watch: {
		'$i18n.locale': function () {
			for (var input of this.randomData) {
				input.selectedOption.text = this.$t('formview.' + input.selectedOption.value);
			}
			this.options = [
				{ value: "Any Data", text: this.$t("formview.AnyInput"), type: "text" },
				{ value: "Date", text: this.$t("formview.Date"), type: "text" },
				{ value: "Name", text: this.$t("formview.Name"), type: "text" },
				{ value: "Number", text: this.$t("formview.Number"), type: "text" },
				{ value: "Birth number", text: this.$t("formview.Birth number"), type: "text" },
				{ value: "E-mail", text: this.$t("formview.E-mail"), type: "text" },
				{ value: "Phone number", text: this.$t("formview.Phone number"), type: "text" },
				{ value: "Postal code", text: this.$t("formview.Postal code"), type: "text" },
				{ value: "ID number", text: this.$t("formview.ID number"), type: "text" },
				{ value: "Passport number", text: this.$t("formview.Passport number"), type: "text" },
				{ value: "IBAN number", text: this.$t("formview.IBAN number"), type: "text" },
				// { value: "Datum-2", text: "Dátum-2", type: "date-custom" },
			]
		}
	},
	setup() {
		const { cookies } = useCookies();
		const showRegexCheckBox = ref(false);
		const date = ref(new Date());
		const formatDate = (date) => {
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();

			return `Selected date is ${day}/${month}/${year}`;
		};

		return {
			cookies,
			date,
			formatDate,
			showRegexCheckBox

		};
	},
	data() {
		return {
			dmsFileId: null,
			pdfFactory: undefined,
			pdfData: undefined,
			pdfPages: 0,
			pdfurl: '',
			loadTask: undefined,
			showProgress: false,
			progressText: "",
			progressPercent: 0,
			pollingInterval: null,
			ocrTaskId: null,
			templateNames: [],
			templates: [],
			showRandomData: true,
			randomData: [
				{
					key: "key1",
					key2: "key2",
					key3: "key3",
					value: "",
					category: "AnyInput",
					as_prefix: false,
					as_suffix: false,
					diacriticsChecked: false,
					hidden_value: "",
					activeSelect: false,
					selectedOption: {
						text: this.$t("formview.AnyInput"),
						value: "AnyInput",
						type: "text",
					},
				},
			],
			templateModalOpen: false,
			templateNameModalOpen: false,
			ocrHelpModalOpen: false,
			ocrCurrentProcesses: 0,
			ocrCombinedCap: 0,
			ocrStatusInterval: undefined,
			isOcrFree: true,
			ocrFileCheck: undefined,
			index: 0,
			counter: 0,
			minusSvg: require("../assets/images/button_delete_icon.svg"),
			infoSvg: require("../assets/images/button_info_questionmark.svg"),
			prefixOn: require('../assets/images/button_prefix_on.svg'),
			prefixOff: require('../assets/images/button_prefix_off.svg'),
			suffixOn: require('../assets/images/button_suffix_on.svg'),
			suffixOff: require('../assets/images/button_suffix_off.svg'),
			presnaZhodaOn: require('../assets/images/button_presnaZhoda_on.svg'),
			presnaZhodaOff: require('../assets/images/button_presnaZhoda_off.svg'),
			formData: new FormData(),
			workingStatus: this.$t("StoreCommits.workingStatus"),
			message: '',//this.$t("LoadingMessages.pdfLoading"),

			options: [
				{ value: "Any Data", text: this.$t("formview.AnyInput"), type: "text" },
				{ value: "Date", text: this.$t("formview.Date"), type: "text" },
				{ value: "Name", text: this.$t("formview.Name"), type: "text" },
				{ value: "Number", text: this.$t("formview.Number"), type: "text" },
				{ value: "Birth number", text: this.$t("formview.Birth number"), type: "text" },
				{ value: "E-mail", text: this.$t("formview.E-mail"), type: "text" },
				{ value: "Phone number", text: this.$t("formview.Phone number"), type: "text" },
				{ value: "Postal code", text: this.$t("formview.Postal code"), type: "text" },
				{ value: "ID number", text: this.$t("formview.ID number"), type: "text" },
				{ value: "Passport number", text: this.$t("formview.Passport number"), type: "text" },
				{ value: "IBAN number", text: this.$t("formview.IBAN number"), type: "text" },
				// { value: "Datum-2", text: "Dátum-2", type: "date-custom" },
			],
			ocrOptions: [
				{ value: 'OCR', text: 'Ocr' },
				{ value: 'noOcr', text: 'WithoutOcr' },
				{ value: 'Auto', text: 'Automatic' }
			],
			ocrprocess: 'Auto',

		};
	},

	computed: {
		gotMultipleFiles() {
			return this.$store.state.arrayOfDocuments.length > 1;
		},
		inputHasNoValue() {
			return (
				!this.randomData.some(item => item.value !== "")
			);
		},
	},

	methods: {
		getOcrStatus() {
			this.axios.get(EnvProvider.value('API_URL') + this.$root.API_OCR_STATUS)
				.then(response => {
					if (response.status === 200) {
						let files = response.data
						this.ocrCurrentProcesses = files.active_processes
						this.ocrCombinedCap = files.combined_ocr_cap

						if (this.ocrCurrentProcesses >= this.ocrCombinedCap) {
							this.isOcrFree = false
							console.log('OCR IS FULL')
						}
						else {
							this.isOcrFree = true
						}
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		grabValues(templateName) {
			console.log("grabbing values");
			let template = {
				name: templateName,
				values: {}
			};

			for (var index in this.randomData) {
				const input = this.randomData[index];
				const inputName = index;

				if (input.value !== '') {
					console.log(input);
					template.values[inputName] = {
						"category": input.selectedOption.value,
						"type": input.selectedOption.value,
						"input_value": input.value,
						"as_prefix": input.as_prefix,
						"as_suffix": input.as_suffix,
						"diacritics": input.diacriticsChecked
					}
				}
			}
			this.templates.push(template);


			this.axios.post(EnvProvider.value('API_URL') + this.$root.API_TEMPLATES_POST, template)
				.then(response => {
					if (response.status === 200) {
						console.log("Templates sent");
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		handleClick(e) {
			if (e.target.classList.contains("modalTemplates")) {
				this.templateModalOpen = false;
			}
			// if (e.target.classList.contains("modalNameTemplates")) {
			// 	this.templateNameModalOpen = false;
			// }
		},
		showTemplateModal() {
			this.getTemplates();
			this.templateModalOpen = true;
		},
		closeTemplateModal() {
			this.templateModalOpen = false;
		},
		showTemplateNameModal() {
			this.getTemplates();
			this.templateNameModalOpen = true;
		},
		closeTemplateNameModal() {
			this.templateNameModalOpen = false;
		},
		showOcrHelpModal() {
			this.ocrHelpModalOpen = true
		},
		closeOcrHelpModal() {
			this.ocrHelpModalOpen = false
		},
		applyTemplate(template) {
			this.randomData = [];

			for (const key in template.values) {
				const templateValue = template.values[key];
				const existingInput = this.randomData.find(input => input.selectedOption.value === templateValue.input_value);

				if (existingInput) {
					existingInput.value = templateValue.input_value;
				} else {
					this.randomData.push({
						key: this.generateRandomString(16),
						key2: this.generateRandomString(16),
						key3: this.generateRandomString(16),
						value: templateValue.input_value,
						category: templateValue.category,
						hidden_value: "",
						activeSelect: false,
						as_prefix: templateValue.as_prefix,
						as_suffix: templateValue.as_suffix,
						diacriticsChecked: templateValue.diacritics,
						selectedOption: {
							text: this.$t("formview." + templateValue.category),
							value: templateValue.type,
							type: "text",
						},
					});
				}
			}
		},
		async applyManualTemplate(template) {
			const files = this.$store.state.arrayOfDocuments;
			var axiosPromises = []
			let values = await this.sendFilesToAnonyma(true, true);
			let fileIds = values[0]
			let docIds = values[1]
			console.log("FILEIDS", fileIds);
			console.log("docIDS", docIds)
			for (let index = 0; index < files.length; index++) {
				let resp = this.manual(files[index], fileIds[index], docIds[index], template);
				axiosPromises.push(resp);
			}

			await Promise.all(axiosPromises);

			this.$store.commit('pushMsg', { type: 'ok', text: 'Dokumenty boly úspešne zanonymizované' });
			this.$router.push({
				name: 'DownloadView'
			});

		},
		async manual(file, fileName, documentId, template) {
			const reader = new FileReader();
			var objects_to_annotate = Object.values(template.values);

			await new Promise((resolve) => {
				reader.onload = () => {
					resolve();
				};
				reader.readAsArrayBuffer(file);
			});

			const pdfData = new Uint8Array(reader.result);
			const loadTask = getDocument({ data: pdfData });

			const pdfDocument = await loadTask.promise;
			const data = await pdfDocument.getData();
			const pdfFactory = new AnnotationFactory(data);

			let annotatedData;
			try {
				for (let index = 0; index < objects_to_annotate.length; index++) {
					const element = objects_to_annotate[index];
					if (element.type == '/Highlight') {
						pdfFactory.createHighlightAnnotation({
							page: element.page,
							rect: element.rect,
							contents: element.contents,
							author: element.author,
							color: element.color
						});
					} else if (element.type == '/Square') {
						pdfFactory.createSquareAnnotation({
							page: element.page,
							rect: element.rect,
							contents: element.contents,
							author: element.author,
							color: element.color
						});
					}
				}
				annotatedData = pdfFactory.write();
			} catch (error) {
				console.error("Error during annotation creation or writing:", error);
				this.$store.commit("pushMsg", {
					type: "error",
					text: this.$t("formview.templateApplyError"),
				});
				throw error;
			}

			let formData = new FormData()
			let dataBlob = new Blob([annotatedData], { type: 'application/pdf' })
			formData.append('file', dataBlob)
			formData.append('fileName', fileName)
			console.log("Pushing PDF to server...")
            console.log("Filename: " + fileName)
			formData.append('documentId', documentId)

			const resp = await this.axios.post(
				EnvProvider.value('API_URL') + this.$root.API_ANON,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						'x-csrf-token': this.cookies.get('csrfToken')
					}
				}
			);

			return resp
		},
		sendTemplates() {
			this.axios.post(EnvProvider.value('API_URL') + this.$root.API_TEMPLATES_POST, this.templates)
				.then(response => {
					if (response.status === 200) {
						console.log("Templates sent");
					}
				}).catch(error => {
					console.log(error);
				});
		},
		removeTemplates() {
			this.axios.post(EnvProvider.value('API_URL') + this.$root.API_TEMPLATES_DEL, this.templates)
				.then(response => {
					if (response.status === 200) {
						console.log("Templates sent");
					}
				}).catch(error => {
					console.log(error);
				});
		},
		removeTemplate(template) {
			const indexToRemove = this.templates.indexOf(template);
			if (indexToRemove !== -1) {
				this.templates.splice(indexToRemove, 1);
				this.removeTemplates()
			}
		},
		getTemplates() {
			this.axios.get(EnvProvider.value("API_URL") + this.$root.API_TEMPLATES_GET, this.templates)
				.then(response => {
					if (response.status === 200) {
						console.log("Templates received");
						let data = JSON.parse(response.data);
						if (Object.keys(data).length === 0) {
							this.templates = []
						}
						else {
							this.templates = data.templates
						}
						console.log('******');
						console.log(response.data)
						this.templateNames = this.templates.map(template => template.name);
					}
				}).catch(error => {
					console.log(error);
				});
		},
		datePickerShow(value) {
			if (value === "date-custom") {
				return true;
			}
			return false;
		},
		datePickerHide(value) {
			if (value === "date-custom") {
				return false;
			}
			return true;
		},
		activateSelect(key) {
			// console.log(this.randomData)
			// console.log("activateSelect key ", key);
			let field = this.randomData.find((x) => x.key === key);
			window.addEventListener('keydown', function (event) {
				if (event.key === 'Escape') {
					field.activeSelect = false;
					event.stopPropagation()
				}
			})
			if (field.activeSelect) {
				// console.log("idem ho zatvorit");
				field.activeSelect = false;
			} else {
				// console.log("otvaram");
				field.activeSelect = true;
			}
			// console.log("activateSelect field", field);
		},
		generateRandomString(length) {
			const characters =
				"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			let result = "";

			for (let i = 0; i < length; i++) {
				const randomIndex = Math.floor(Math.random() * characters.length);
				result += characters.charAt(randomIndex);
			}

			return result;
		},
		addFormField() {
			this.randomData.push({
				key: this.generateRandomString(16),
				key2: this.generateRandomString(16),
				key3: this.generateRandomString(16),
				value: "",
				category: "AnyInput",
				hidden_value: "",
				activeSelect: false,
				as_prefix: false,
				as_suffix: false,
				diacriticsChecked: false,
				selectedOption: { text: this.$t("formview.AnyInput"), value: "AnyInput", type: "text" },
			});
		},
		removeFormField(index) {
			this.randomData.splice(index, 1);
		},
		checkFileOcr() {
			console.log('Processing file and checking if OCR is needed')

			const files = this.$store.state.arrayOfDocuments;
			let formData = new FormData();
			const allAttributes = this.prepareDataIntoAnnotationNewFormView();
			for (let index = 0; index < files.length; index++) {
				console.log('inside for loop: ' + index)
				formData.append('file', files[index]);
				formData.append("formJSON", JSON.stringify(allAttributes));
				formData.append("ocr", this.ocrprocess)
				if (files.length > 1) {
					var zip_id = uuidv4();
					formData.append('zip_id', zip_id);
				}
			}

			this.axios.post(EnvProvider.value("API_URL") + this.$root.API_OCR_FILE_CHECK, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
					uToken: this.cookies.get("userToken"),
				},
			})
				.then((response) => {
					if (response.status === 200) {
						console.log(response.data['ocrCheck'])
						this.ocrFileCheck = response.data['ocrCheck']
					}
				})
		},
		async sendFilesToAnonyma(manualAnnotation, fromTemplate) {
			this.$store.state.showOverlay = true;
			console.log("Diacritics checked: " + this.diacriticsChecked);

			const allAttributes = this.prepareDataIntoAnnotationNewFormView();
			var newAllAttributes = []

			for (let i = 0; i < allAttributes.length; i++) {
				if (allAttributes[i].content[0].value !== '') {
					newAllAttributes.push(allAttributes[i]);
				}
			}
			this.$store.commit("pushMsg", {
				type: "ok",
				text: this.$t("StoreCommits.sentForProcessing"),
			});

			const files = this.$store.state.arrayOfDocuments;

			if (files.length > 1) {
				var zip_id = uuidv4();
				if (manualAnnotation && !fromTemplate) {
					console.error("Illegal situation. Cannot do manual annotation with a template.")
					this.$store.commit("pushMsg", {
						type: "error",
						text: this.$t("StoreCommits.processingError"),
					});
					return
				}
			}

			let dataResponse = null
			var axiosCalls = []
			let fileIds = {}
			let documentIds = {}
			console.log(allAttributes)

			for (let index = 0; index < files.length; index++) {
				console.log('inside for loop: ' + index)

				if (this.ocrprocess === 'Auto' && this.ocrFileCheck !== false) {
					this.ocrTaskId = Math.ceil(Math.random() * 1000000).toString();
				} else if (this.ocrprocess === 'OCR') {
					this.ocrTaskId = Math.ceil(Math.random() * 1000000).toString();
				}

				const formData = new FormData();
				formData.append('file', files[index]);
				formData.append("formJSON", JSON.stringify(allAttributes));
				if (this.dmsFileId) {
					formData.append("dms_document_id", this.dmsFileId);
				}
				formData.append("manual", manualAnnotation);
				formData.append("ocr", this.ocrprocess)
				formData.append("ocr_id", this.ocrTaskId);
				formData.append("check_diacritics", this.diacriticsChecked);
				if (files.length > 1) {
					formData.append('zip_id', zip_id);
				}

				const axiosPromise = await this.axios.post(
					EnvProvider.value("API_URL") + this.$root.API_POST,
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							uToken: this.cookies.get("userToken"),
						},
					}
				).then((response) => {
					console.log('response:')
					console.log(response.data)
					fileIds[index] = response.data.fileid
					documentIds[index] = response.data.doc_id

					if (response.data.ocrstatus === 'full') {
						console.log('CAPACITY FULL')
						console.log(response.data.activeocrdocs)
						console.log(response.data.allOcrCap)
					} else if (manualAnnotation === true) {
						dataResponse = response.data
					} else {
						this.$store.commit("pushMsg", {
							type: "ok",
							text: this.$t("StoreCommits.successfulAnnot"),
						});
					}
				}).catch((error) => {
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						if(error.response.data.status == 'canceled'){
							this.$store.commit("pushMsg", {
								type: "error",
								text: this.$t("StoreCommits.ocrCanceled"),
							});
						} else {
							console.log(error.response.data);
							this.$store.commit("pushMsg", {
								type: "error",
								text: this.$t("StoreCommits.processingError"),
							});
						}
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
						this.$store.commit("pushMsg", {
							type: "error",
							text: this.$t("StoreCommits.processingError"),
						});
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.request);
						this.$store.commit("pushMsg", {
							type: "error",
							text: this.$t("StoreCommits.processingError"),
						});
					}
					this.$store.state.showOverlay = false;
					this.ocrTaskId = "";
				}
				);
				axiosCalls.push(axiosPromise)
			};

			await Promise.all(axiosCalls);

			this.$store.state.showOverlay = false;
			this.ocrTaskId = "";

			if (files.length > 1) {
				if (manualAnnotation === true) {
					if (fromTemplate === true) {
						// 1+ file, manual YES, template YES
						// return fileIds
						return [fileIds, documentIds]
					} else {
						// 1+ file, manual YES, template NO
						// illegal
						console.error("This should not happen");
						return
					}
				} else {
					if (fromTemplate === true) {
						// 1+ file, manual NO, template YES
						// go to download view
						this.$store.commit('pushMsg', { type: 'ok', text: 'Dokumenty boly úspešne anonymizované' });
						this.$router.push({
							name: 'DownloadView'
						});
					} else {
						// 1+ file, manual NO, template NO
						// go to download view
						this.$store.commit('pushMsg', { type: 'ok', text: 'Dokumenty boly úspešne anonymizované' });
						this.$router.push({
							name: 'DownloadView'
						});
					}
				}
			} else {
				if (manualAnnotation === true) {
					if (fromTemplate === true) {
						// 1 file, manual YES, template YES
						// return fileIds
						return [fileIds, documentIds]
					} else {
						// 1 file, manual YES, template NO


						// go to manual annotation view
						let minexData = JSON.stringify(dataResponse.minex);
						console.log(dataResponse);
						this.$router.push({
							name: "ManualAnnotationView",
							params: {
								filename: dataResponse.filename,
								fileId: dataResponse.fileid,
								minex: minexData,
								documentId: dataResponse.doc_id,
								fromDMS: this.dmsFileId ? true : false,
							},
						});
					}
				} else {
					if (fromTemplate === true) {
						// 1 file, manual NO, template YES
						// go to download view
						this.$store.commit('pushMsg', { type: 'ok', text: this.$t('StoreCommits.successfulAnnot') });
						this.$router.push({
							name: 'DownloadView'
						});
					} else {
						// 1 file, manual NO, template NO
						// go to download view
						this.$store.commit('pushMsg', { type: 'ok', text: this.$t('StoreCommits.successfulAnnot') });
						this.$router.push({
							name: 'DownloadView'
						});
					}
				}
			}
		},
		prepareDataIntoAnnotation() {
			var allAttributes = [];
			var anonymizedFields = this.$root.anonymizedFields;
			for (var section in anonymizedFields) {
				var sectionData = {
					categoryName: this.$t(anonymizedFields[section].label),
					content: [],
				};
				const params = anonymizedFields[section].parameters;
				for (var field in params) {
					if (params[field].input !== "") {
						var singleParameter = {
							inputName: this.$t(params[field].label),
							value: params[field].input,
						};
						sectionData.content.push(singleParameter);
					}
				}
				if (sectionData.content.length !== 0) {
					allAttributes.push(sectionData);
				}
			}
			if (this.randomData || this.randomData !== "") {
				sectionData = {
					categoryName: this.$t("StoreCommits.anyParam"),
					content: [],
				};
				singleParameter = {
					inputName: "randomData",
					value: this.randomData,
				};
				sectionData.content.push(singleParameter);
				allAttributes.push(sectionData);
			}
			return allAttributes;
		},
		prepareDataIntoAnnotationNewFormView() {
			var allAttributes = [];
			if ((this.randomData.length > 1) || (this.randomData[0].value !== "")) {
				for (var form in this.randomData) {
					var sectionData = {
						categoryName: "non-categoric",
						content: [],
					};
					var singleParameter = {
						inputName: this.randomData[form].category,
						value: this.randomData[form].value,
						as_prefix: this.randomData[form].diacriticsChecked ? false : this.randomData[form].as_prefix,
						as_suffix: this.randomData[form].diacriticsChecked ? false : this.randomData[form].as_suffix,
						diacritics: this.randomData[form].diacriticsChecked
					};
					sectionData.content.push(singleParameter);
					allAttributes.push(sectionData);
				}
			}
			return allAttributes;
		},
		cancelOcrJob() {
			if (!this.ocrTaskId) return;
			const url = `${EnvProvider.value("API_URL")}${this.$root.API_OCR_CANCEL}/${this.ocrTaskId}`;

			// Use sendBeacon (always POST) for unload events
			if (navigator.sendBeacon) {
				navigator.sendBeacon(url);
			} else {
				// Fallback for browsers without sendBeacon
				const img = new Image();
				img.src = url;
			}
		}
	},
	created() {
		this.$store.state.showOverlay = false;

		setTimeout(() => {
			let documentLink = "";
			this.dmsFileId = this.$route.query.DMSFileID;

			// ak prišiel DMSFileID → používame iný endpoint
			if (this.dmsFileId) {
				this.$store.state.showOverlay = true;
				console.log("Fetching file from DMS with DMSFileID:", this.dmsFileId);
				const url =
					EnvProvider.value("API_URL") +
					'/documents/dms-link' +              // nový endpoint
					"?fileId=" +
					encodeURIComponent(this.dmsFileId);

				this.axios
					.get(url, {
						headers: {
							"Content-Type": "application/octet-stream",
						},
						responseType: "blob",
					})
					.then((response) => {
						this.$store.state.showOverlay = false;
						if (response.status === 200) {
							var filename = this.dmsFileId + ".pdf"; // ak DMS nevracia názov
							const contentDisposition = response.headers['content-disposition'];
							console.log("Content-Disposition header:", contentDisposition);
							console.log("Response headers:", response.headers);
							console.log("Response data:", response.data);
							if (contentDisposition) {
								const match = contentDisposition.match(/filename="?([^"]+)"?/);
								if (match && match.length > 1) {
									filename = match[1];
								}
							}
							const file = new File([response.data], filename, {
								type: response.headers["content-type"] || "application/octet-stream",
							});
							this.$store.commit("setDocuments", [file]);
							console.log(this.$store.state.arrayOfDocuments);
						} else {
							this.$store.commit("pushMsg", {
								type: "error",
								text: this.$t("StoreCommits.downloadError"),
							});
						}
					});
				return; // dôležité – nechceme pokračovať do documentLink vetvy
			}

			// pôvodná logika pre documentLink
			if (this.$route.query.documentLink) {
				this.$store.state.showOverlay = true;
				documentLink = decodeURIComponent(this.$route.query.documentLink);

				this.axios
					.get(
						EnvProvider.value("API_URL") +
							this.$root.API_CRZ +
							"?documentLink=" +
							documentLink,
						{
							headers: {
								"Content-Type": "application/octet-stream",
							},
							responseType: "blob",
						}
					)
					.then((response) => {
						this.$store.state.showOverlay = false;
						if (response.status === 200) {
							const filename = documentLink.split("/").pop();
							const contentType =
								response.headers["content-type"] || "application/octet-stream";
							const file = new File([response.data], filename, {
								type: contentType,
							});
							this.$store.commit("setDocuments", [file]);
							console.log(this.$store.state.arrayOfDocuments);
						} else {
							this.$store.commit("pushMsg", {
								type: "error",
								text: this.$t("StoreCommits.downloadError"),
							});
						}
					});
			}
		}, 200);

		setTimeout(() => {
			this.checkFileOcr();
		}, 200);

		this.getOcrStatus();
		this.ocrStatusInterval = setInterval(this.getOcrStatus, 5000);
	},
	mounted() {
		// Browser/tab close or external navigation
    	window.addEventListener('beforeunload', this.cancelOcrJob);

		// Browser back/forward buttons
    	window.addEventListener('popstate', this.cancelOcrJob);

		if (this.$router) {
			this.unregisterGuard = this.$router.beforeEach((to, from, next) => {
				if (from.name === 'OcrViewer') {
				this.cancelOcrJob();
				}
				next();
			});
		}
	},

	beforeUnmount() {
		window.clearInterval(this.ocrStatusInterval)
		this.cancelOcrJob();

		window.removeEventListener('beforeunload', this.cancelOcrJob);
		window.removeEventListener('popstate', this.cancelOcrJob);

		if (this.unregisterGuard) {
		this.unregisterGuard();
		}
	},
};
</script>

<style lang="scss" scoped src="@/assets/css/views/FormView.scss" />
<style lang="scss" scoped src="@/assets/css/components/Ocr.scss" />

